export const STORY_BIBLE_STYLE_ID = "story-bible-style";
export const STORY_BIBLE_STYLE_NAME = "Story Bible Style";

export const STORY_BIBLE_STYLE_SELECTION = {
  source: "story_bible",
  id: STORY_BIBLE_STYLE_ID,
  name: STORY_BIBLE_STYLE_NAME,
};

export const CUSTOM_STYLE_SELECTION = {
  source: "custom",
  name: "Your Custom Style",
};

export const DEFAULT_STYLE_GUIDE_BUILT_IN_ID = "refined-literary";

export const STYLE_GUIDE_BUILT_IN_STYLES = [
  {
    id: DEFAULT_STYLE_GUIDE_BUILT_IN_ID,
    name: "Refined & Literary",
    tag: "Sudowrite",
    description: "Polished literary prose with precise imagery and layered interiority.",
    promptStyleText:
      "Use polished, literary prose with precise imagery, layered interiority, and carefully varied sentence rhythm.",
    writingSample: `The cloying scent of lilies and hypocrisy choked me as I sat rigid in my chair, surrounded by a sea of beaming faces. Pastor Mike's voice dripped like poisoned honey through the reception hall.

"And now, let's share some cherished memories of the happy couple..."

Happy. The word tasted bitter on my tongue. My fingers dug into my palms as I watched Dad beam at his new wife. The room blurred as hot tears pricked my eyes. How dare they act like this was normal, like he had not torn our family apart and dressed it up as destiny.`,
  },
  {
    id: "action-packed",
    name: "Action-Packed",
    tag: "Sudowrite",
    description: "Fast momentum, immediate physical action, and crisp sentence rhythm.",
    promptStyleText:
      "Use fast-paced adventure prose with short sentences, immediate physical action, punchy verbs, and light description that keeps momentum high.",
    writingSample: `Jacques leapt over a chasm as the floor crumbled beneath his feet, ancient staff clutched tightly in his white-knuckled grip. The pyramid rumbled ominously.

"Not today," he muttered, hitting the ground running.

A glint of metal caught his eye. He ducked, feeling the whoosh of air as a blade trap swung inches above his head. Jacques vaulted over a fallen pillar, rolled hard, and came up sprinting toward the sliver of daylight ahead.`,
  },
  {
    id: "approachable-charming",
    name: "Approachable & Charming",
    tag: "Sudowrite",
    description: "Warm, conversational prose with easy humor and a welcoming voice.",
    promptStyleText:
      "Use warm, approachable prose with a conversational rhythm, light humor, clear emotional cues, and charming character observations.",
    writingSample: `Sophia stood outside her bakery with a hand pressed to her mouth as smoke billowed out the front door. A fireman approached, his face smudged with soot, and held up one blackened loaf like an apology.

"I managed to save one," he said. "Sort of."

A laugh caught in Sophia's throat and came out halfway to a sob. "Thank you," she murmured, cradling the ruined loaf. "I don't know whether to laugh or cry."`,
  },
  {
    id: "dark-foreboding",
    name: "Dark & Foreboding",
    tag: "Sudowrite",
    description: "Atmospheric tension, ominous sensory detail, and controlled pacing.",
    promptStyleText:
      "Use dark, foreboding prose with atmospheric sensory detail, ominous foreshadowing, restrained pacing, and a persistent sense of unease.",
    writingSample: `I paced the gloomy halls of my crumbling manor, hunger gnawing at my gut. The harvest moon's sickly glow seeped through tattered curtains, taunting me.

"What's a soul to do on such a night?" I asked the empty room.

The house answered with a groan from deep in its timbers. Somewhere below, a latch clicked, though I had locked every door before sundown.`,
  },
  {
    id: "sultry",
    name: "Sultry",
    tag: "Sudowrite",
    description: "Sensual, intimate prose with charged subtext and tactile detail.",
    promptStyleText:
      "Use sultry prose with intimate sensory detail, charged subtext, lingering glances, tactile language, and emotionally heightened pacing.",
    writingSample: `Sasha slid into the chair across from Sloan and pretended not to notice the clean line of her collarbone beneath the lamplight. The library was too warm, too quiet, every whispered page turn sharpening the space between them.

Sloan leaned over the textbook. "Pronounce this."

Their sleeves brushed. Sasha lost the word entirely.`,
  },
  {
    id: "gritty",
    name: "Gritty",
    tag: "Sudowrite",
    description: "Raw, grounded prose with blunt detail and unsentimental intensity.",
    promptStyleText:
      "Use gritty prose with grounded physical detail, blunt dialogue, unsentimental emotional beats, and a raw, immediate texture.",
    writingSample: `Gary's van rattled to a stop in front of the house, coughing smoke from the tailpipe. He wiped sweat from his brow and grabbed the toolbox with hands that would not quite stop shaking.

The condenser unit hummed around back, loud and wrong. Gary crouched beside it, smelled burnt metal, and muttered, "Yeah. This one's gonna cost somebody."`,
  },
];

export function getStyleGuideBuiltInStyleById(id) {
  if (typeof id !== "string") return null;
  return STYLE_GUIDE_BUILT_IN_STYLES.find((style) => style.id === id) || null;
}

export function getStyleGuideBuiltInStyleByName(name) {
  if (typeof name !== "string") return null;
  const normalizedName = name.trim().toLowerCase();
  return STYLE_GUIDE_BUILT_IN_STYLES.find((style) => style.name.toLowerCase() === normalizedName) || null;
}
